import React from 'react';
import { bool, string } from 'prop-types';
import styled from 'styled-components';
import { Heading } from 'components/elements';
import DropdownDvr from './RecordingsDvr/DropdownDvr';

const Container = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	padding: 0 0.5rem;
	margin-bottom: 2.4rem;
`;

const Title = styled(Heading.First)`
	color: ${({ theme }) => theme.white};
	font-size: 2.2rem;
	margin: 0;
	z-index: 2;
`;

export function RecordingsHeader({ title, withDropdownDvr }) {
	return (
		<Container>
			<Title>{title}</Title>
			{withDropdownDvr && <DropdownDvr />}
		</Container>
	);
}

RecordingsHeader.propTypes = {
	title: string.isRequired,
	withDropdownDvr: bool
};
